export const LOGIN = "LOGIN"
export const NEW_TOKEN = "NEW_TOKEN"
export const MENU = "MENU"
export const NOTE_COUNT = "NOTE_COUNT"
